/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Select_WarehouseInputs */

const en_audit_select_warehouse = /** @type {(inputs: Audit_Select_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select warehouse`)
};

const es_audit_select_warehouse = /** @type {(inputs: Audit_Select_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar almacen`)
};

/**
* | output |
* | --- |
* | "Select warehouse" |
*
* @param {Audit_Select_WarehouseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_select_warehouse = /** @type {((inputs?: Audit_Select_WarehouseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Select_WarehouseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_select_warehouse(inputs)
	return es_audit_select_warehouse(inputs)
});